import { render, staticRenderFns } from "./ApplyStatusTag.vue?vue&type=template&id=5a0d36f8"
import script from "./ApplyStatusTag.vue?vue&type=script&lang=ts"
export * from "./ApplyStatusTag.vue?vue&type=script&lang=ts"
import style0 from "./ApplyStatusTag.vue?vue&type=style&index=0&id=5a0d36f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_prettier@2.2.1_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports